const awsmobile = {
    "aws_project_region": import.meta.env.VITE_AWS_PROJECT_REGION,
    "aws_user_pools_id": import.meta.env.VITE_AWS_USER_POOL_ID,
    "aws_user_pools_web_client_id": import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID
};  export default awsmobile;